import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isObject } from 'lodash-es';
import { InlineGroupComponent } from '../../structural/inline-group/inline-group.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';
export type ModalError = {
  error: string;
  message?: string[] | Record<string, string[]>;
  details?: Record<string, string[]>;
};

@Component({
  selector: 'woo-error-modal',
  imports: [ModalLayoutComponent, InlineGroupComponent, CommonModule],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent extends BaseModalComponent<ModalError> {
  public status = this.modaldata;

  isStringArray(value: unknown): value is string[] {
    return isObject(value) && !Array.isArray(value);
  }
}
